<template>
  <div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
  </el-row>
  <el-row>
    <el-input v-loading="loading" type="textarea" :rows="20" placeholder="데이터가 없습니다." :readonly="true" v-model="processText">
    </el-input>
  </el-row>
</div>
</template>
<script>
import { analysisTimeType } from '@/constants/performance';
import msgUtil from '@/utils/message';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WProcessTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      loading: false,
      processText: null,
      checkDatetime: null,
    };
  },
  methods: {
    /**
     * 프로세스를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        const params = {
          objId: this.selectedNode.obj.objId,
          baselineDatetime: this.plotLineDatetime,
          managetypeId: 'NMS',
        };
        this.loading = true;
        netdeviceTableInfoAPI.getProcessSnapshot(params).then((response) => {
          if (response.data.success === true) {
            const snapshotData = response.data.data;
            this.processText = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.loading = true;
        netdeviceTableInfoAPI.getProcessList(this.selectedNode.obj.objId).then((response) => {
          if (response.data.success === true) {
            this.processText = response.data.data;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '프로세스', false));
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/ProcessTable.vue